export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
export const CREATE_CLASSROOM = "CREATE_CLASSROOM";
export const TURN_OFF_LOADING_ACTION = 'TURN_OFF_LOADING_ACTION';
export const TURN_ON_LOADING_ACTION = 'TURN_ON_LOADING_ACTION';
export const SET_CLASSROOM_DATA = 'SET_CLASSROOM_DATA'
export const ADD_CLASSROOM_CREATE_PENDING = 'ADD_CLASSROOM_CREATE_PENDING';
export const SET_CLASSROOM_ACTIVE_USERS_ACTION = 'SET_CLASSROOM_ACTIVE_USERS_ACTION';
export const SET_LOGGED_USER_ACTION = 'SET_LOGGED_USER_ACTION';
